import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent, HttpErrorResponse, HttpEventType } from '@angular/common/http';
import { Http } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators';

import 'rxjs/add/operator/map';
import 'rxjs';

@Injectable()
export class MyservicesService {

  public stageTitle: string;
  public apiPath = 'https://www.ikolilu.com/api/v1.0/portal.php/';
  public apiStudentsPortalapiPath = 'https://www.ikolilu.com/api/v1.0/studentsportalapi.php/';

  constructor(private http: Http, private httpClient: HttpClient) { }


  public UpoadAssServices(data, userId) {
    const localPath = this.apiPath + 'UploadAssignment/';

    return this.httpClient.post<any>(localPath, data, {
      reportProgress: true,
      observe: 'events'
    }).pipe(map((event) => {

      switch (event.type) {

        case HttpEventType.UploadProgress:
          const progress = Math.round(100 * event.loaded / event.total);
          return { status: 'progress', message: progress };

        case HttpEventType.Response:
          return event.body;
        default:
          return -1;
      }
    })
    );
  }
  public checkShareableFile(url) {
    const localPath = this.apiPath + 'is_404/?filelink=' + url + '';
    return this.http.get(localPath,  {}).pipe(map((response: any) => response.json()));
  }
  public shareAssignmentlink(data) {
    const localPath = this.apiPath + 'ShareAssignmentLink/';
    return this.http.post(localPath, data,  {}).pipe(map((response: any) => response.json()));
  }
  public getCustomizeLogin(schoolid) {
    const localPath = this.apiPath + 'getSchoolInfo/?szschoolid=' + schoolid + '';
    return this.http.get(localPath, {}).pipe(map((response: any) => response.json()));
  }
  // get Lessons
  public getmyLessons(sttudentid, szclassid, szclassgroup, schoolid) {
    // studclass,stuclgroup,szschoolid
    // tslint:disable-next-line:max-line-length
    const localPath = this.apiPath + 'getStudenLessonsList_A/?studentid=' + sttudentid + '&szclassid=' + szclassid + '&szclassgroup=' + szclassgroup + '&szschoolid=' + schoolid + '';
    return this.http.get(localPath, {}).pipe(map((response: any) => response.json()));
  }
  // studentDownloadLesson

  public getMarkLessonDownload(studentid, schoolid, lessoncode) {
    // studclass,stuclgroup,szschoolid
    // tslint:disable-next-line:max-line-length
    const localPath = this.apiPath + 'studentDownloadLesson/?studentid=' + studentid + '&szschoolid=' + schoolid + '&szlessoncode=' + lessoncode + '';
    return this.http.get(localPath, {}).pipe(map((response: any) => response.json()));
  }


  public getMarkAttendance(studentid, schoolid, lessoncode) {
    // studclass,stuclgroup,szschoolid
    // tslint:disable-next-line:max-line-length
    const localPath = this.apiPath + 'StudentVAttendance/?studentid=' + studentid + '&szschoolid=' + schoolid + '&szlessoncode=' + lessoncode + '';
    return this.http.get(localPath, {}).pipe(map((response: any) => response.json()));
  }

  public getStudentAssignments(studentid, schoolid) {
    // studclass,stuclgroup,szschoolid
    // tslint:disable-next-line:max-line-length
    const localPath = this.apiPath + 'getStudentAssignsList/?studentid=' + studentid + '&szschoolid=' + schoolid + '';
    return this.http.get(localPath, {}).pipe(map((response: any) => response.json()));
  }

  public getGradedStudentAssignments(studentid, schoolid) {
    // studclass,stuclgroup,szschoolid
    // tslint:disable-next-line:max-line-length
    const localPath = this.apiPath + 'getStudentGradedAssignsList/?studentid=' + studentid + '&szschoolid=' + schoolid + '';
    return this.http.get(localPath, {}).pipe(map((response: any) => response.json()));
  }
  public getStudentVirtualClasses(studentid, schoolid) {
    // studclass,stuclgroup,szschoolid
    // tslint:disable-next-line:max-line-length
    const localPath = this.apiPath + 'getStudentVClassList/?studentid=' + studentid + '&szschoolid=' + schoolid + '';
    return this.http.get(localPath, {}).pipe(map((response: any) => response.json()));
  }
  public getStudentDetailsOnLogin(studentid) {
    // studclass,stuclgroup,szschoolid
    // tslint:disable-next-line:max-line-length
    const localPath = this.apiPath + 'GetMyStudentInfo/?studentid=' + studentid + '';
    return this.http.get(localPath, {}).pipe(map((response: any) => response.json()));
  }

  public getStudentDetailsOnLoginA(studentid, schoolid) {
    // studclass,stuclgroup,szschoolid
    // tslint:disable-next-line:max-line-length
    const localPath = this.apiPath + 'GetMyStudentInfoA/?studentid=' + studentid + '&sz_schoolid=' + schoolid + '';
    return this.http.get(localPath, {}).pipe(map((response: any) => response.json()));
  }

  public dropUploadedfile(studentid, acccode, filename, schoolid) {
    // tslint:disable-next-line:max-line-length
    const localPath = this.apiPath + 'DeleteUploadedAssignment/?studentid=' + studentid + '&assignmentno=' + acccode + '&szfile=' + filename + '&schoolid=' + schoolid + '';
    return this.http.get(localPath).map(res => res.json());
  }


}
